import styled, { keyframes } from "styled-components";
import BgGradient2 from "./assets/10.png";

const line_animation = keyframes`
 from {
    stroke-dashoffset: 1;
  }
  to {
    stroke-dashoffset: 0;
  }
`;
export const IndexPrComponentMainDiv = styled.div`
  width: 100%;
  flex: 1;
  background-size: cover;
  background: rgba(0, 0, 0, 1);

  background-repeat: no-repeat;
  border-radius: 12px;
  background-image: url(${BgGradient2});

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex: 1;
    flex-direction: column;
    gap: 24px;
    padding: 50px 0 0 0;
    height: 376px;
    border-radius: 16px;
  }
  .index-pr-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    padding: 0 4rem;
    width: 100%;
  }

  .index-pr-cards-container {
    display: flex;
    align-items: stretch;
    width: 180px;
    justify-content: space-between;
    flex-direction: column;
    gap: 24px;
  }

  .index-pr-card-container {
    border-radius: 16px;
    backdrop-filter: blur(10px);
    height: auto;
    padding: 16px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    > div {
      display: flex;
      gap: 18px;
    }
  }
  .index-pr-agent-card-container {
  }
  .index-pr-running-line {
    stroke-dasharray: 1;
    stroke: rgba(255, 255, 255, 0.7);
    animation: ${line_animation}   linear;
    animation-timeline: view();
    animation-range: cover 20% cover 100%;

    stroke-dashoffset: 1;
  }
  .index-pr-svg-holder {
    width: 100%;
    position: absolute;
    height: 300px;
    overflow: visible !important;

    > svg {
      width: 100%;
      height: 100%;
      fill: green;

    }
  }

  .index-pr-action-card-container {
    flex: 1;
  }
  .index-pr-logo-card-container {
    border-radius: 100%;
    background: rgba(0, 0, 0, 1);
  }

  .index-pr-card-logo-container {
    width: 60px;
    height: 60px;
    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .index-pr-card-text-container {
    > p {
      padding: 0px;
      margin: 0px;
      font-size: 16px;
      font-family: "Inter", "Inter Placeholder", sans-serif;

      font-weight: 400;
    }
    > h3 {
      padding: 0px;
      margin: 8px;
      font-size: 18px;
      font-family: "Inter", "Inter Placeholder", sans-serif;

      font-weight: 500;
    }
  }
`;
